export default __webpack_public_path__ + "static/maxxbw3-ea61fa4f6cd38c96c51939061538abfd.png";